module.exports = __webpack_public_path__ + "images/help/icon-twr38@2x-ac473abb015beb4bc0a38bb1f3e1dba5.png";